const capitalize = ([head, ...tail]) => head.toUpperCase() + tail.join("");

export { capitalize };
